import { render } from "./PageWrapper.vue?vue&type=template&id=57fa60ff&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"

import "./PageWrapper.vue?vue&type=style&index=0&id=57fa60ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fa60ff"]])

export default __exports__